import * as React from 'react';
import { Button, Box, Card, CardContent, Checkbox, FormControlLabel, MenuItem, TextField, Typography } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate, Link, Navigate as Redirect, withRouter } from 'react-router-dom';
import firebase from "firebase/compat/app";
import Auth from './Auth';
import ProtectedRoutes from './ProtectedRoutes';


function Entry({ auCheck }) {

    const [avainArvo, asetaAvainArvo] = React.useState("");
    let navigate = useNavigate();


    const handleSubmit = (event) => {
        if (avainArvo.toString() === "Tahdon22") {


            Auth.login(() => {
            });


            //auCheck(true);
            navigate("/etusivu");

        }
        else {
            //console.log("Väärä avain.");

        }

    }

    const handleChange = (event) => {
        let uusiAvainArvo = event.target.value;
        asetaAvainArvo(uusiAvainArvo)

        //console.log(Auth.isAuthenticated())
    }

    return (
        <div
            //onLoad={console.log(Auth.isAuthenticated())}
            
        >
            <div>
                <div
                    style={{
                        minHeight: '100vh',
                        //display: 'flex-row',
                        display: 'flex',
                        justifyContent: 'center',
                        // Muuntele asettelua myöhemmin
                        //alignItems: 'center',
                        flexWrap: 'wrap',
                    }}
                >
                    <Box>

                        <Card
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                flex: 'wrap',
                                //height: '100%',
                                //width: '100%',
                                marginTop: '20vh',
                                width:
                                {
                                    xs: '75vw',
                                    sm: '75vw',
                                    md: '40vw',
                                    lg: "40vw"
                                },
                                //textAlign: 'center',

                            }}
                        >
                            <Typography
                                gutterBottom variant="h5"
                                component="h2"
                                //className={classes.title}
                                sx={{
                                    width: '100%',
                                    paddingLeft: 2,
                                    paddingRight: 2,
                                    paddingTop: 2,
                                    fontSize: '2em',
                                    /*fontSize:
                                    {
                                        xs: '4.2vh',
                                        sm: '4.2vh',
                                        md: '3.2vw',
                                        lg: "2.0vw"
                                    },*/
                                }}
                            >
                                Hei
                            </Typography>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                component="p"
                                //className={classes.breadText}
                                sx={{
                                    width: '100%',
                                    paddingLeft: 2,
                                    paddingRight: 2,
                                    margin: 0,
                                    fontSize: '1.2em'
                                    /*fontSize:
                                    {
                                        xs: '2.8vh',
                                        sm: '3.5vh',
                                        md: "1.95vw",
                                        lg: "1.3vw"
                                    },
                                    */
                                }}
                            >
                                Päästäksesi sivulle, syötä kutsussa annettu avain.
                            </Typography>
                            <Box
                                sx={{
                                    margin: '1vw',
                                }}
                            >
                                <TextField
                                    sx={{
                                        width: '100%',
                                    }}
                                    id="outlined-secondary"
                                    label="Kutsuavain"
                                    variant="outlined"
                                    color="secondary"
                                    name="key"
                                    onChange={handleChange}
                                />
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'stretch',
                                    margin: '0vw 1vw 1vw 1vw',
                                }}
                            >
                                <Button
                                    type="submit"
                                    sx={{
                                        width: '100%',
                                        backgroundColor: '#3260a8',
                                        fontSize: '1.2em'
                                    }}
                                    variant="contained"
                                    color="secondary"

                                    onClick={handleSubmit}
                                /*Auth.login(() => {
                                    
                                })    
                                //*/
                                //}
                                //onClick={() => handleRemoveFields()}

                                >
                                    SYÖTÄ AVAIN
                                </Button>
                            </Box>
                        </Card>
                    </Box>
                </div>
            </div>
        </div>
    );
}

export default Entry;